import React from "react";
import { Button, Modal } from "react-bootstrap";
import useTicket from "../../../hooks/useTicket";
import { toast } from "react-toastify";

class DownloadAttachmentModal extends React.Component {
    DownloadAttachments = (file) => {
        const { downloadAttachment, onClose } = this.props;

        downloadAttachment(
            file.id,
            (result)=>{
                toast.success("Download degli allegati avvenuto con successo");
                const a = document.createElement("a");
                a.href =
                "data:application/" +
                file.nomeFile +
                ";base64," +
                result;
                a.download = file.nomeFile;
                a.title = file.nomeFile;
                a.click();

            },
            ()=>{
               toast.error("Errore nel download degli allegati, riprova")
            }
           );
             onClose();
    }

    render() {
        const { selectedTicketDetails, show, onClose } = this.props;

        return (
            <>
            <Modal show={show} onHide={onClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Scarica Allegati Ticket</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <fieldset className="detail-fieldset">
                <legend className="detail-legend">File caricati</legend>
                <div className="w-100">
                  {selectedTicketDetails?.allegati?.length < 1 ? <p className="m-0">Non ci sono file caricati</p> :
                  selectedTicketDetails?.allegati?.map((file) => {
                    return (
                      <div key={file.id} className="d-flex justify-content-between py-2 border px-2 br-8">
                        <div className="d-flex align-items-center">{file.id}</div>
                        <div className="d-flex align-items-center">{file.nomeFile}</div>
                        <div className="d-flex gap-2">
                          <Button
                            variant="warning"
                            className="cursor-pointer"
                            onClick={() => this.DownloadAttachments(file)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-download"
                              viewBox="0 0 16 16"
                            >
                              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                            </svg>
                            </Button>
                        </div>
                      </div>
                    );
                  })}
                  </div>
              </fieldset>
                </Modal.Body>
            </Modal>
            </>
        )
    }
}

const DownloadAttachmentModalWrapper = (props) => {
    const { downloadAttachment } = useTicket();

    return <DownloadAttachmentModal {...props} downloadAttachment={downloadAttachment} />;
};

export default DownloadAttachmentModalWrapper;
